import fetch from "./fetch";
/**
 * 权限
 */
const operations = {
  // 标签列表
  labelRequst(data) {
    return fetch({
      isLoading: true,
      url: "/v1/label/page",
      method: "GET",
      params: data,
    });
  },
  // 新增标签
  addLabelRequst(data) {
    return fetch({
      isLoading: true,
      url: "/v1/label/save",
      method: "POST",
      data,
    });
  },

  // 编辑标签
  editLabelRequst(data) {
    return fetch({
      isLoading: true,
      url: "/v1/label/update",
      method: "POST",
      data,
    });
  },
  // 广告列表
  bannerListRequst(data) {
    return fetch({
      isLoading: true,
      url: "/v1/banner/page",
      method: "GET",
      params: data,
    });
  },
  // 新增广告
  addBannerRequst(data) {
    return fetch({
      isLoading: true,
      url: "/v1/banner/add",
      method: "POST",
      data,
    });
  },
  // 编辑广告
  updateBannerRequst(data) {
    return fetch({
      isLoading: true,
      url: "/v1/banner/update",
      method: "POST",
      data,
    });
  },
  // 删除广告
  deleteBannerRequst(data) {
    return fetch({
      isLoading: true,
      url: "/v1/banner/delete",
      method: "POST",
      data,
    });
  },

  // 职称列表
  professionalRequst(data) {
    return fetch({
      isLoading: true,
      url: "/professionalTitle/page",
      method: "GET",
      params: data,
    });
  },

  // 职称模糊查询
  professionalQuerySearch(data) {
    return fetch({
      isLoading: false,
      url: "/professionalTitle/selectByName",
      method: "GET",
      params: data,
    });
  },
  // 职位新增
  professionalSave(data) {
    return fetch({
      isLoading: true,
      url: "/professionalTitle/save",
      method: "POST",
      data,
    });
  },
  // 职位编辑
  professionalEdit(data) {
    return fetch({
      isLoading: true,
      url: "/professionalTitle/update",
      method: "POST",
      data,
    });
  },

  // 科室列表
  departmentRequst(data) {
    return fetch({
      isLoading: true,
      url: "/v1/department/page",
      method: "GET",
      params: data,
    });
  },
  // 科室新增
  departmentAdd(data) {
    return fetch({
      isLoading: true,
      url: "/v1/department/save",
      method: "POST",
      data,
    });
  },
  // 科室编辑
  departmentEdit(data) {
    return fetch({
      isLoading: true,
      url: "/v1/department/update",
      method: "POST",
      data,
    });
  },
  // 科室模糊查询
  departmentQuerySearch(data) {
    return fetch({
      isLoading: false,
      url: "/v1/department/selectByName",
      method: "GET",
      params: data,
    });
  },
  // 审批列表查询
  kfjkPatientSelectPage(data) {
    return fetch({
      isLoading: true,
      url: "/kfjkPatient/selectPage",
      method: "GET",
      params: data,
    });
  },
  // 审批详情
  kfjkPatientGetByUserId(data) {
    return fetch({
      isLoading: true,
      url: "/kfjkPatient/getByUserId",
      method: "GET",
      params: data,
    });
  },
  // 提交审核
  kfjkPatientSubmit(data) {
    return fetch({
      isLoading: true,
      url: "/kfjkPatient/submit",
      method: "POST",
      data,
    });
  },
  // 审批记录
  getApprovalRequest(data) {
    return fetch({
      isLoading: true,
      url: "/approvalProcess/getApproval",
      method: "GET",
      params: data,
    });
  },
  // 患者修改记录
  getCureUpdateRecordRequest(data) {
    return fetch({
      isLoading: true,
      url: `/cureUpdateRecord/getCure?userId=${data}`,
      method: "GET",
      params: {},
    });
  },

  // 医院模糊匹配
  getHospitalSelectLikeRequest(data) {
    return fetch({
      isLoading: true,
      url: `/hospital/selectLike`,
      method: "GET",
      params: data,
    });
  },
  // 用户标签--获取树型用户标签数据
  getUserLabelTreeData(params) {
    !params.pid && (params.pid = '');
    return fetch({
      isLoading: false,
      url: `/dm-label-plus/list`,
      method: "GET",
      params
    });
  },
  // 用户标签--新增二级标签
  addUserLabel(data) {
    return fetch({
      isLoading: true,
      url: `/dm-label-plus/save`,
      method: "POST",
      data
    });
  },
  // 用户标签--获取标签内容列表
  getLabelContentListData(data) {
    return fetch({
      isLoading: true,
      url: `/dm-label-plus/page`,
      method: "GET",
      params: data
    });
  },
  // 用户标签--编辑删除标签
  updateLabel(data) {
    return fetch({
      isLoading: true,
      url: `/dm-label-plus/update`,
      method: "POST",
      data
    });
  },
  // 获取患者详情
  getPatientDetailData(id,isLoading) {
    return fetch({
      isLoading,
      url: `/patient/detail/${id}`,
      method: "POST",
    });
  },
  // 患者详情--增加标签
  detailAddLabel(data) {
    return fetch({
      isLoading: true,
      url: `patient/labelLink?labelId=${data.labelId}&patient=${data.patient}`,
      method: "POST",
    });
  },
  // 患者详情--删除标签
  detailDeleteLabel(data) {
    return fetch({
      isLoading: true,
      url: `patient/labelLinkDel?labelId=${data.labelId}&patient=${data.patient}`,
      method: "POST",
    });
  },
  // 更新患者信息内容
  updatePatient(data) {
    return fetch({
      isLoading: true,
      url: `/patient/update`,
      method: "POST",
      data
    });
  },
  // 新增用户附件
  addPatiendAttach(data) {
    return fetch({
      isLoading: true,
      url: `/patient-attachment/save`,
      method: "POST",
      data
    });
  },
  // 删除用户附件
  deletePatiendAttach(data) {
    return fetch({
      isLoading: true,
      url: `/patient-attachment/update`,
      method: "POST",
      data
    });
  }
};

export default operations;
